import Vue from "vue/dist/vue.js"
import Vuex from "vuex"

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    /**national code in register with sejam */
    nationalcode: null,

    /**verified sejam by nationalcode or not */
    verifiedSejam: false,

    /**fund details */
    fund: {
      gender: null,
      fatherName: null,
      id: null,
      placeOfIssue: null /**محل صدور */,
      birthday: null,
      fullName: null,
    },

    count: 0,

    investor: {
      address: null,
      sex: null,
      firstName: null,
      lastName: null,
      fullName: null,
      fatherName: null,
      mobile: null,
      postalCode: null,
      idCardNumber: null,
      investorId: null,
      cardPlace: null,
      melliNumber: null,
      birthDayDate: null,
      accountNumber: null,
    }
  },
  mutations: {
    /**increment count */
    increment(state) {
      state.count++
    },

    /**set fund details */
    setFund(state, payload) {
      // state.fund.gender = playload['s:Body']['GetFundDetailResponse']['']
    },

    /**set investor details */
    setInvestor(state, payload) {
      state.investor = payload
    },

    /**set investor details */
    setInvestorSex(state, payload) {
      state.investor.sex = payload
    },

    /**set national code in sejam signup*/
    setNationalcode(state, payload) {
      state.nationalcode = payload
    },

    /**set user sejam verified */
    setUserSejamVerified(state) {
      state.verifiedSejam = true;
    }
  },
  getters: {
    getInvestor: (state, getters) => {
      return state.investor
    }
  },
  actions: {
    increment(context) {
      context.commit('increment')
    }
  }
});

export default store